import axios from 'axios';

import createUrlWithParams from 'helpers/createUrlWithParams';

import {
  parseAllActionLibraryInstancesForFE,
  parseActionLibraryInstanceListForFE,
  parseBulkCreateActionLibraryInstanceForBE,
  parseUpdateActionLibraryInstanceForBE,
} from './actionLibraryInstance.parsers';
import type { ActionLibraryInstanceAPI } from './actionLibraryInstance.types';

const endpoint = 'api/v1/asset-actions/';

export const actionLibraryInstancesApi: ActionLibraryInstanceAPI = {
  getAllActionLibraryInstances: async params => {
    const { data } = await axios.get(createUrlWithParams(endpoint, params || {}));

    // If data is an array (not paginated), handle it:
    if (Array.isArray(data)) {
      return {
        data: {
          count: data.length,
          next: null,
          previous: null,
          results: parseAllActionLibraryInstancesForFE(data),
        },
      };
    }

    // Default paginated response handling
    return {
      data: {
        count: data.count || 0,
        next: data.next || null,
        previous: data.previous || null,
        results: parseAllActionLibraryInstancesForFE(data.results || []),
      },
    };
  },

  getSingleActionLibraryInstance: async id => {
    const { data } = await axios.get(`${endpoint}${id}/`);
    return { data: parseActionLibraryInstanceListForFE(data) };
  },

  deleteActionLibraryInstance: async id => {
    await axios.delete(`${endpoint}${id}/`);
  },

  createBulkActionLibraryInstances: async data => {
    const { data: responseData } = await axios.post(`${endpoint}create_bulk/`, parseBulkCreateActionLibraryInstanceForBE(data));
    return { data: responseData };
  },
  updateActionLibraryInstance: async (id, data) => {
    const { data: responseData } = await axios.patch(`${endpoint}${id}/`, parseUpdateActionLibraryInstanceForBE(data));
    return { data: parseActionLibraryInstanceListForFE(responseData) };
  },
};

export default actionLibraryInstancesApi;
